import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { AdminContextService } from "../../modules/admin/context/admin-contex.service";
import { AdminService } from "../../modules/admin/services/admin.service";
import { GestionContextService } from "../../modules/gestion/context/getion-context.service";
import { GestionService } from "../../modules/gestion/services/gestion.service";
import { Message, SpinnerService } from "shared-components";

@Component({
  selector: "app-traducciones",
  templateUrl: "./traducciones.component.html",
})
export class TraduccionesComponent implements OnInit {
  private _filters;
  public traduccionForm: UntypedFormGroup;
  public showError: boolean;
  public mensajes = new Array<Message>();
  public objetos;
  private _objeto;
  private _editable: boolean;
  private _toDelete: any;
  public deleteModal = false;
  public editable;
  private _traduccion;

  @Input() objetoId;
  @Input() traduccion;
  @Input() nombreComponente;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() mensaje = new EventEmitter<string>();
  @Output() editableChanged = new EventEmitter<any>();
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _gestionContextService: GestionContextService,
    private readonly _gestionService: GestionService,
    private readonly _adminContext: AdminContextService,
    private readonly _adminService: AdminService,
    private readonly _dataProvider: DataProvider
  ) {}

  ngOnInit() {
    this.traduccionForm = this._fb.group({
      idioma: ["", Validators.required],
      traduccion: ["", Validators.required],
    });

    if (this.traduccion) {
      this._traduccion = this.traduccion[Object.keys(this.traduccion)[2]];
      this.traduccionForm.disable();
      this.editable = false;
      this.traduccionForm.patchValue({
        idioma: this.idiomas.find(
          (x) => x.id === this.traduccion.idiomaId
        ),
        traduccion: this._traduccion,
      });
    } else {
      this.editable = true;
      this.traduccionForm.enable();
    }
  }

  public get idiomas() {
    return this._dataProvider.idiomas;
  }

  public applyFilters() {
    if (this.nombreComponente === "MantenimientoProductosComponent") {
      this._gestionContextService.productosIdiomaFilters = {
        productoId: this.objetoId,
        idiomaId: this.traduccionForm.get("idioma").value,
      };
      this.getObjetos();
    }
  }

  public getObjetos() {
    if (this.nombreComponente === "MantenimientoProductosComponent") {
      this._spinnerService.showSpinner();
      this._gestionService
        .getProducto(this.objetoId)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          this.objetos = resp.lista;
        });
    }

    if (this.nombreComponente === "MantenimientoPaisesComponent") {
      this._spinnerService.showSpinner();
      this._gestionService
        .getProducto(this.objetoId)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          this.objetos = resp.lista;
        });
    }
  }

  public save() {
    this.checkForm();
    if (this.traduccionForm.valid && this.objetoId) {
      if (this.nombreComponente === "MantenimientoProductosComponent") {
        this._objeto = {
          productoId: this.objetoId,
          idiomaId: this.traduccionForm.get("idioma").value.id,
          desProducto: this.traduccionForm.get("traduccion").value,
        };
        this._spinnerService.showSpinner();
        this._gestionService
          .createProductoIdioma(this._objeto)
          .toPromise()
          .finally(() => {
            this._spinnerService.hideSpinner();
          })
          .then((resp) => {
            if (resp) {
              this.refresh.emit(true);
              this.pushMessage("global.success.itemCreated");
            } else {
              this.showError = true;
              this.mensajes = [];
              this.mensajes.push({
                class: "error",
                message: "global.error.noResponse",
              });
            }
          });
      }
    }

    if (this.nombreComponente === "MantenimientoPaisesComponent") {
      this._objeto = {
        paisId: this.objetoId,
        idiomaId: this.traduccionForm.get("idioma").value.id,
        desPais: this.traduccionForm.get("traduccion").value,
      };
      this._spinnerService.showSpinner();
      this._adminService
        .createPaisIdioma(this._objeto)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          if (resp) {
            this.refresh.emit(true);
            this.pushMessage("global.success.itemCreated");
          } else {
            this.showError = true;
            this.mensajes = [];
            this.mensajes.push({
              class: "error",
              message: "global.error.noResponse",
            });
          }
        });
    }
  }

  public delete() {
    this._spinnerService.showSpinner();
    if (this.nombreComponente === "MantenimientoProductosComponent") {
      this._gestionService
        .deleteProductoIdioma(this.objetoId, this.traduccion.idiomaId)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage("global.success.itemDeleted");
        });
    }

    if (this.nombreComponente === "MantenimientoPaisesComponent") {
      this._adminService
        .deletePaisIdioma(this.objetoId, this.traduccion.idiomaId)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage("global.success.itemDeleted");
        });
    }
  }

  public askDelete(traduccion) {
    this._toDelete = traduccion.id;
    this.deleteModal = true;
  }

  public closeModal() {
    this.deleteModal = false;
    this._toDelete = "";
  }

  public cancel() {
    if (!this.traduccion) {
      this.close.emit(false);
    }
  }

  public edit(traduccion) {
    this.traduccionForm.enable();
  }

  public checkForm() {
    this.showError = this.traduccionForm.invalid;
    this.mensajes = [];
    if (this.showError) {
      this.mensajes.push({ class: "error", message: "global.error.required" });
    }
  }

  public pushMessage(mensaje) {
    this.showError = true;
    this.mensajes = [];
    this.mensajes.push({ class: "success", message: mensaje });
  }
}
